// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DataViewLoadingOverlay, {
    DataViewLoadingOverlayProps,
} from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { baseGridProps } from "@store/Themes/common/props/baseGrid";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface OrderLayoutProps extends ExpandStyles<OrderLayoutStyles>, DataViewLoadingOverlayProps {
    id: string;
}

export interface OrderLayoutStyles {
    loadingOverlay?: LoadingOverlayProps;
    container?: GridContainerProps;
    mainColumn?: GridItemProps;
    sideColumnMobile?: GridItemProps;
    sideColumnDesktop?: GridItemProps;
    sideColumnWrapper?: InjectableCss;
}

export const orderLayoutStyles: OrderLayoutStyles = {
    loadingOverlay: { minHeight: 150 },
    container: baseGridProps.container,
    mainColumn: {
        width: [12, 12, 7, 8, 9],
        printWidth: 12,
    },
    sideColumnMobile: {
        width: [12, 12, 0, 0, 0],
        printWidth: 0,
    },
    sideColumnDesktop: {
        width: [0, 0, 5, 4, 3],
        printWidth: 12,
    },
    sideColumnWrapper: {
        css: css`
            position: sticky;
            top: ${pxToRem(20)};
            width: 100%;
        `,
    },
};

const OrderLayout: FC<OrderLayoutProps> = ({
    id,
    loading,
    loadComplete,
    dataView,
    preload,
    extendedStyles,
    overridedStyles,
}) => {
    const styles = useExpandProps(orderLayoutStyles, extendedStyles, overridedStyles);

    return (
        <DataViewLoadingOverlay
            dataView={dataView}
            loading={loading}
            loadComplete={loadComplete}
            preload={preload}
            {...styles.loadingOverlay}
        >
            <GridContainer {...styles.container}>
                <GridItem {...styles.sideColumnMobile}>
                    <Zone contentId={id} zoneName="Side" />
                </GridItem>
                <GridItem {...styles.mainColumn}>
                    <Zone contentId={id} zoneName="Content" />
                </GridItem>
                <GridItem {...styles.sideColumnDesktop}>
                    <StyledWrapper {...styles.sideColumnWrapper}>
                        <Zone contentId={id} zoneName="Side" />
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </DataViewLoadingOverlay>
    );
};

export default OrderLayout;
